import React from 'react';
import { faqs } from '../data/mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQSection = ({ limit }) => {
  const items = limit ? faqs.slice(0, limit) : faqs;
  return (
    <section id="faq" className="bg-neutral-50">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <div className="text-center mb-16">
          <p className="text-neutral-500 text-xs uppercase tracking-[0.35em] mb-4">Answers</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-neutral-900 font-bold tracking-tight">
            Frequently Asked Questions
          </h2>
          <div className="mt-6 mx-auto w-16 h-px bg-neutral-900" />
        </div>

        <Accordion type="single" collapsible className="space-y-2">
          {items.map((item) => (
            <AccordionItem
              key={item.q}
              value={item.q}
              className="border border-neutral-200 bg-white px-6 data-[state=open]:shadow-sm transition-shadow"
            >
              <AccordionTrigger className="text-left font-serif text-lg text-neutral-900 hover:no-underline py-5">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-neutral-700 leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
